'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import ControlBarActionTooltip from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarActionTooltip';
import IconViverseLogo from '@/components/assets/icon_viverse_logo.svg';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useWorldDetailsContext } from '@/context/WorldDetailsContext';
import { useEnableViewMode } from '@/hooks/useEnableViewMode';
import { buildShareUrl } from '@/lib/share-link';
import { cn } from '@/lib/utils';
type ControlBarEmbedLogoButtonProps = {
  className?: string;
  popupContainer?: HTMLDivElement | null;
  /**
   * `play-on` always prefixes the logo with the `Play on` label; `responsive` shows the label only
   * when the enclosing container is 769px or wider. One instance serves every width so the logo's
   * gradient id is never duplicated into a hidden copy.
   */
  variant: 'play-on' | 'responsive';
};
export default function ControlBarEmbedLogoButton(t0) {
  const $ = _c(26);
  const {
    className,
    popupContainer,
    variant
  } = t0;
  const t = useTranslations();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const {
    is3DCommerce
  } = useWorldDetailsContext();
  const enableViewMode = useEnableViewMode();
  const t1 = is3DCommerce || enableViewMode;
  let t2;
  if ($[0] !== roomData.hub_sid || $[1] !== t1) {
    t2 = buildShareUrl(roomData.hub_sid, {
      view: t1
    });
    $[0] = roomData.hub_sid;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const worldUrl = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("control-bar.play-on-viverse");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== className) {
    t4 = cn("flex h-[34px] shrink-0 items-center justify-center gap-2 rounded-full bg-white/8 px-4 py-2 backdrop-blur-[12px] hover:bg-white/20 hover:backdrop-blur-[50px]", className);
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = variant === "responsive" && "@min-embed-lg/embed:inline hidden";
  let t6;
  if ($[7] !== t5) {
    t6 = cn("text-sm leading-[22px] font-semibold tracking-[0.15px] whitespace-nowrap text-white", t5);
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("control-bar.play-on");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <span className={t6}>{t7}</span>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconViverseLogo className="h-[14px] w-auto shrink-0" aria-hidden="true" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t8 || $[18] !== worldUrl) {
    t10 = <a data-action="embed-logo" href={worldUrl} target="_blank" rel="noopener noreferrer" aria-label={t3} className={t4}>{t8}{t9}</a>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t8;
    $[18] = worldUrl;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const logoButton = t10;
  if (variant === "play-on") {
    return logoButton;
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("control-bar.play-on-viverse");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== logoButton || $[23] !== popupContainer || $[24] !== t11) {
    t12 = <ControlBarActionTooltip contentClassName="@min-embed-lg/embed:hidden" label={t11} portalContainer={popupContainer}>{logoButton}</ControlBarActionTooltip>;
    $[22] = logoButton;
    $[23] = popupContainer;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}